import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/src/components/Docs/DocsLayout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Experiment`}</h1>
    <p>{`Check which variation of an experiment is assigned to a user. A `}<inlineCode parentName="p">{`userId`}</inlineCode>{` and `}<inlineCode parentName="p">{`attributes`}</inlineCode>{` could be optionally supplied.`}</p>
    <h2>{`Hook`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import { useExperiment } from 'react-tesfy';

const Component = () => {
  const variationId = useExperiment({ id: 'experiment-1' }); // '1'
  // or
  const userId = '676380e0-7793-44d6-9189-eb5868e17a86';
  const attributes = { countryCode: 'us' };
  const variationId = useExperiment({
    id: 'experiment-1',
    userId,
    attributes
  }); // '1'
};
`}</code></pre>
    <h2>{`Component`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import { Experiment, Variation } from 'react-tesfy';

const userId = '676380e0-7793-44d6-9189-eb5868e17a86';
const attributes = { countryCode: 'us' };

const Component = () => (
  <Experiment id="experiment-1" userId={userId} attributes={attributes}>
    <Variation>
      Not rendered
    </Variation>
    <Variation id="0">
      Not rendered
    </Variation>
    <Variation id="1">
      Rendered
    </Variation>
  </Experiment>
);
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      